import { Suspense, lazy, memo } from "react";

import { AsyncDataSuspense } from "@tsp-core/async/components/async-data-suspense";

import { contractorsAccountsApi } from "@tsp-domains/contractor-accounts/api";
import { systemTypesApi } from "@tsp-domains/system-types/api";

const Content = lazy(() => import("./linking-paysera-account.content"));

function PayseraLinkingPage() {
  const loadContractorsAccountsQuery = contractorsAccountsApi.useGetContractorsAccountsQuery();
  const getSystemTypesDictionaryQuery = systemTypesApi.useGetSystemTypesDictionaryQuery();

  return (
    <AsyncDataSuspense queries={[loadContractorsAccountsQuery, getSystemTypesDictionaryQuery]}>
      <Suspense fallback={<div>Loading...</div>}>
        <Content />
      </Suspense>
    </AsyncDataSuspense>
  );
}

export default memo(PayseraLinkingPage);
